import { render, staticRenderFns } from "./forgot_pass.vue?vue&type=template&id=49c72f7c&scoped=true&"
import script from "./forgot_pass.vue?vue&type=script&lang=js&"
export * from "./forgot_pass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c72f7c",
  null
  
)

export default component.exports